import { SITUACAO_COMPONENTE } from "src/components/vendas/types";
import { Projeto } from "../types";

export function verificaPendenciaTrocaComponente(projetoState?: Projeto): boolean {
  let pendenteAplicacao = false;
  const substituidos = projetoState?.componentes_modificados?.filter(item => item.situacao === SITUACAO_COMPONENTE.NOVO && !!item.componente_substituido_id) || [];
  if (substituidos.length) {
    const ids = substituidos.map(item => item.componente_id);
    const componentesIds = projetoState?.componentes?.map(item => item.componente_id) || [];
    for (const id of ids) {
      if (!componentesIds.includes(id)) pendenteAplicacao = true;
    }
  }
  return pendenteAplicacao;
}